<div class="toast-container" [class.auth-toast]="isAuthPage">
  <div *ngFor="let toast of toasts"
       class="custom-toast {{toast.type}}"
       [class.removing]="toast.removing">

    <!-- ICON FIXED -->
    <svg *ngIf="toast.type === 'success'" class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
         viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>

    <svg *ngIf="toast.type === 'error'" class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
         viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M12 9v3.75m0 3.75h.008M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>

    <svg *ngIf="toast.type === 'warning'" class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
         viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M12 9v3.75m0 3.75h.008M10.29 3.86l-7.4 12.82A1.5 1.5 0 004.3 19h15.4a1.5 1.5 0 001.3-2.32L13.7 3.86a1.5 1.5 0 00-2.6 0z" />
    </svg>

    <svg *ngIf="toast.type === 'info'" class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
         viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836M12 8.25h.008M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>

    <span class="toast-message">{{ toast.message }}</span>

    <button class="toast-close" (click)="dismiss(toast.id)">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none"
       viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round"
      d="M6 18L18 6M6 6l12 12" />
  </svg>
</button>


    <div class="toast-progress animate"></div>
  </div>
</div>
